module.exports = __webpack_public_path__ + "img/Join-us_text-01.36d3e661.jpg";